import { render } from "./SocialLinks.vue?vue&type=template&id=048d9deb&scoped=true"
const script = {}

import "./SocialLinks.vue?vue&type=style&index=0&id=048d9deb&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048d9deb"]])

export default __exports__